/**
 * ThemeMode represents the possible view options for a given theme
 */
export enum ThemeMode {
    System = 0,
    Light,
    Dark,
}
